import React, { createContext, useContext, ReactNode } from 'react';

interface FontContextType {
  fontFamily: string;
  regularClass: string;
  boldClass: string;
}

const FontContext = createContext<FontContextType | undefined>(undefined);

export const useFont = () => {
  const context = useContext(FontContext);
  if (!context) {
    throw new Error('useFont must be used within a FontProvider');
  }
  return context;
};

interface FontProviderProps {
  children: ReactNode;
}

export const FontProvider: React.FC<FontProviderProps> = ({ children }) => {
  const value: FontContextType = {
    fontFamily: 'Phetsarath, sans-serif',
    regularClass: 'phetsarath-regular',
    boldClass: 'phetsarath-bold',
  };

  return <FontContext.Provider value={value}>{children}</FontContext.Provider>;
}; 